import { render, staticRenderFns } from "./Cgc.vue?vue&type=template&id=6ff6e848&scoped=true&"
import script from "./Cgc.vue?vue&type=script&lang=js&"
export * from "./Cgc.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=6ff6e848&prod&scoped=true&lang=css&"
import style1 from "./Cgc.vue?vue&type=style&index=1&id=6ff6e848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6e848",
  null
  
)

export default component.exports